import { underlyingsApiConnector } from 'apiConnector/secondary-market/undelyingsApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import {
  secondaryMarketUnderlyingsSearchFailed,
  secondaryMarketUnderlyingsSearchReceived,
} from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

export function searchUnderlyingsEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('SECONDARY_MARKET_UNDERLYINGS_SEARCH_REQUESTED'),
      filter(({ keys }) => keys.length > 0),
      mergeMap(({ keys }) =>
        underlyingsApiConnector(httpClient)
          .getUnderlyingsByKeys(keys)
          .pipe(
            map(underlyings => secondaryMarketUnderlyingsSearchReceived(underlyings)),
            catchError((err: HttpError) =>
              of(secondaryMarketUnderlyingsSearchFailed(keys, extractHttpErrorMessage(err))),
            ),
          ),
      ),
    );
}
